import React, { useRef } from 'react';
import './familyForm.css';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { familyFormAction, userFormAction } from "../../redux/rootReducer";
import { getUsersForSubscriptionSagaAction, updateSubscriptionFamilyListSagaAction } from "../../redux/sagaActions";
import growl from "../../lib/growl/growl";
import { FAMILY_FORM_INITIAL, USER_FORM_INITIAL } from "../../redux/initialStateConstant";

const FamilyForm = () => {
    const history = useHistory();
    const dispatch = useDispatch();

    const familyForm = useSelector(state => state.familyForm);

    // Таймер для отсрочки запроса посетителей на сервере
    const timer = useRef(0);

    const getUsers = text => {

        if (timer.current) clearTimeout(timer.current);

        if (!text.trim()) {
            dispatch(familyFormAction({
                ...familyForm,
                users: [],
                userInput: ''
            }));
            return false;
        }

        // Делаем задержку для набора текста
        timer.current = setTimeout(() => {
            dispatch(getUsersForSubscriptionSagaAction({ text, type: 'familyForm' }));
        }, 500);
    };

    if (!familyForm.open) return false;

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <i className="form__close"
                           onClick={ () => dispatch(familyFormAction(FAMILY_FORM_INITIAL)) }
                        />
                        <div className="form__title">Семейный абонемент</div>
                    </div>
                    <>
                        {
                            familyForm?.owner?.id &&
                            <div className="form__field">
                                <div className="input__caption">Владелец абонемента</div>
                                <div className="family__user">
                                    <div className="family__user-number"/>
                                    <div className="family__user-name table__cell--hover"
                                        onClick={ () => {
                                            // Закрываем форму семейного абонемента
                                            dispatch(familyFormAction(FAMILY_FORM_INITIAL));
                                            // Переходим в карточку клиента
                                            history.push('/fitness/users/' + familyForm.owner.id);
                                        } }
                                    >{ familyForm.owner.name }</div>
                                </div>
                            </div>
                        }
                        <div className="form__field">
                            <div className="input__caption">Посетитель (почта или телефон)</div>
                            <div className="dropdown">
                                <input type="text" className="input"
                                       value={ familyForm.userInput || '' }
                                       onInput={ event => {
                                           dispatch(familyFormAction({
                                               ...familyForm,
                                               userInput: event.target.value
                                           }));
                                           // Получение с сервера списка всех пользователей, с совпадением по email или телефону
                                           getUsers(event.target.value);
                                       } }
                                />
                                <div className={ `dropdown__items ${ familyForm.userInput ? 'dropdown__items--open' : false }` }>
                                    {
                                        familyForm.users?.length
                                            ? familyForm?.users?.map(elem => {
                                                return (
                                                    <div className="dropdown__item" key={ elem.id }
                                                         onClick={ () => {
                                                             // Проверяем наличие выбранного пользователя в массиве уже добавленных
                                                             if (familyForm.checkedUsers.findIndex(el => el.id === elem.id) + 1) {
                                                                 growl({ type: 'error', message: 'Посетитель уже добавлен' });
                                                                 return;
                                                             }
                                                             // Добавляем нового пользователя
                                                             dispatch(familyFormAction({
                                                                 ...familyForm,
                                                                 checkedUsers: [...familyForm.checkedUsers, elem],
                                                                 users: [],
                                                                 userInput: ''
                                                             }));
                                                         } }
                                                    >{ `${ elem.name } ${ elem.phone }` }</div>
                                                );
                                            })
                                            : <div className="dropdown__item"
                                                   onClick={ () => {
                                                       // Переходим на страницу с посетителями
                                                       history.push('/fitness/users');
                                                       // Закрываем форму добавления абонемента
                                                       dispatch(familyFormAction({
                                                           ...familyForm,
                                                           open: false
                                                       }));
                                                       // Открываем форму добавления посетителя
                                                       dispatch(userFormAction({
                                                           ...USER_FORM_INITIAL,
                                                           open: true,
                                                           title: 'Новый посетитель'
                                                       }));
                                                   } }
                                            >{ `Добавить посетителя` }</div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="form__field">
                            <div className="input__caption">Посетители</div>
                            {
                                familyForm?.checkedUsers?.map((user, index) => {
                                    return (
                                        <div className="family__user" key={ user.id }>
                                            <div className="family__user-number">{ index + 1 }</div>
                                            <div className="family__user-info">
                                                <div className="family__user-name">{ user.name }</div>
                                                <div className="family__user-phone">{ user.phone }</div>
                                            </div>
                                            <div className="family__user-remove"
                                                 onClick={ () => {
                                                     // Подтверждение удаления пользователя
                                                     if (window.confirm('Вы действительно хотите удалить посетителя?')) {
                                                         // Удаление пользователя из абонемента
                                                         dispatch(familyFormAction({
                                                             ...familyForm,
                                                             checkedUsers: [...familyForm.checkedUsers.filter(el => el.id !== user.id)]
                                                         }));
                                                     }
                                                 } }
                                            />
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </>
                    <div className="form__field">
                        <div className="button"
                             onClick={ () => dispatch(updateSubscriptionFamilyListSagaAction({
                                 subscription_id: familyForm.subscription_id,
                                 checkedUsers: JSON.stringify(familyForm.checkedUsers.map(el => el.id))
                             })) }
                        >Сохранить</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FamilyForm;